import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'

import UnitExerciseListPlaceholder from 'src/pages/UnitExerciseList/UnitExerciseListPlaceholder'
import UnitExerciseList from 'src/pages/UnitExerciseList/UnitExerciseList'
import DataFetchError from 'src/ui/DataFetchError/DataFetchError'

// TO-DO:
// - add Rating
// - add how many times seen and when last
export const FETCH_UNIT_MEDIA = gql`
  query FETCH_UNIT_MEDIA(
    $l1Code: LanguageEnum!
    $l2Code: LanguageEnum!
    $unitId: ID!
  ) {
    curriculum(native: $l1Code, learning: $l2Code) {
      unit(id: $unitId) {
        progress {
          isQueued
          countOfExercisesSeen
        }
        exercises {
          id
          name
          imageUrl
          rating
          timesSeen
          lastSeen
        }
      }
    }
  }
`

const UnitExerciseListLazy = ({ l1Code, l2Code, unitId }) => {
  const response = useQuery(FETCH_UNIT_MEDIA, {
    variables: {
      l1Code,
      l2Code,
      unitId,
    },
  })

  const { data, loading } = response

  const exercises = data?.curriculum?.unit?.exercises
  const showExerciseRating =
    data?.curriculum?.unit?.progress?.countOfExercisesSeen > 0

  if (loading) {
    return <UnitExerciseListPlaceholder />
  }

  if (exercises) {
    return (
      <UnitExerciseList
        exercises={exercises}
        showExerciseRating={showExerciseRating}
        l2Code={l2Code}
      />
    )
  }

  return <DataFetchError graphQLResponse={response} />
}

UnitExerciseListLazy.propTypes = {
  l1Code: PropTypes.string.isRequired,
  l2Code: PropTypes.string.isRequired,
  unitId: PropTypes.string.isRequired,
}

export default UnitExerciseListLazy
